<template>
<svg
   width="16"
   height="16"
   fill="currentColor"
   class="bi bi-square-fill-check"
  viewBox="0 0 16 16"
>
  <path
    style="stroke-width:0.87500006"
    d="M 1.75 0 A 1.75 1.75 0 0 0 0 1.75 L 0 12.25 A 1.75 1.75 0 0 0 1.75 14 L 5.8125 14 A 6 6 0 0 1 5 11 A 6 6 0 0 1 11 5 A 6 6 0 0 1 14 5.8105469 L 14 1.75 A 1.75 1.75 0 0 0 12.25 0 L 1.75 0 z "
    id="path62" />
  <path
    inkscape:connector-curvature="0"
    d="M 16,11 A 5,5 0 1 1 6,11 5,5 0 0 1 16,11 Z M 13.152858,8.6014288 a 0.71428569,0.71428569 0 0 0 -0.980001,0.245715 L 10.501427,11.632856 9.72,10.851429 a 0.71518814,0.71518814 0 0 0 -1.011429,1.011427 l 1.105715,1.104286 a 1.0714285,1.0714285 0 0 0 1.677142,-0.205714 L 13.398571,9.5814275 A 0.71428569,0.71428569 0 0 0 13.152858,8.6014288 Z"
    id="path1075"
    style="stroke-width:1.42857122" />
  <!-- STANDARD SMALL ICON
  <path
     style="stroke-width:0.87500006"
     d="M 1.75 0 A 1.75 1.75 0 0 0 0 1.75 L 0 12.25 A 1.75 1.75 0 0 0 1.75 14 L 8.2636719 14 A 4.5 4.5 0 0 1 8 12.5 A 4.5 4.5 0 0 1 12.5 8 A 4.5 4.5 0 0 1 14 8.2636719 L 14 1.75 A 1.75 1.75 0 0 0 12.25 0 L 1.75 0 z "
     id="path62" />
  <path
      inkscape:connector-curvature="0"
      d="m 16,12.499163 a 3.5000001,3.5000001 0 1 1 -6.9999999,0 3.5000001,3.5000001 0 0 1 6.9999999,0 z m -1.993,-1.679 a 0.5,0.5 0 0 0 -0.686,0.172 l -1.17,1.95 -0.547,-0.547 a 0.5006316,0.5006316 0 0 0 -0.708,0.708 l 0.774,0.773 a 0.75,0.75 0 0 0 1.174,-0.144 l 1.335,-2.226 a 0.5,0.5 0 0 0 -0.172,-0.686 z"
      id="path1075" />
      -->
</svg>
</template>

<script>
// https://icons.getbootstrap.com/icons/square-fill/ +
// https://icons.getbootstrap.com/icons/send-check-fill/
// Via: square-crop.svg to trim a circle out off the square

export default {
  name: "SquareFillCheck"
}
</script>

<style>

</style>